import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroCotaFinanciamentoService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'cotaFinanciamento/excel/deletar', 'excelParametroCotaFinanciamentoDeletar');
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'cotaFinanciamento/excel', 'excelCotaFinanciamento');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('cotaFinanciamento/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('cotaFinanciamento/eventGrid', {});
    }
}

export default ParametroCotaFinanciamentoService;